import { redirectToHomeIfNoAccessGranted } from '@/market-pulse/router/guards';

const MarketPulsePage = () => import('@/market-pulse/pages/market-pulse.vue');

export const marketPulseRoutes = [
  {
    path: '/market-pulse',
    name: 'market-pulse',
    component: MarketPulsePage,
    beforeEnter: redirectToHomeIfNoAccessGranted,
  },
];
